export const environment = {
  name: 'production',
  website_title: 'Serviceportal',
  backend_url: '',
  dev_adyen_backend_url: 'http://localhost:3000',
  adyen_iframe_url: 'https://adyen.arivo.app',
  amplitude_key: 'd368406ba95dc3a4e77bf2ef9abe7469',
  production: true,
  featureFlags: {
    enable_marketing_consent: false,
    enable_contract_creation_dashboard: true,
    enable_contract_creation_products: true,
    enable_contract_termination: true,
    enable_contract_qr_code: true,
    enable_iframe_adyen: true,
    door_opener_qr_code: false,
    enable_app_and_notifications: false,
    enable_cookie_consent: false,
    enable_contract_reference: false,
    enable_external_billing: false,
    enable_signup: true,
    enable_ppu: true,
    enable_wipark_vpi: false,
    enable_amplitude: false,
    enable_public_products: true,
    freeflow_with_group_limit: false,
    dev_enable_demo_login: false,
    dev_enable_demo_login_only: false,
    dev_enable_mock_calls: false,
    dev_payment_method_optional: false,
    translation_key: 'default',
  },
};
